import { getUmbracoMediaUrl } from "./getUmbracoMediaUrl"

export function getUmbracoPDFUrl(url?: string) {
  // Temporary until figure out how to pass Server Env to client component. Possible Solution is prefix
  // GRAPHQL_URL with NEXT_PUBLIC_GRAPHQL_URL
  if (!url) {
    return ""
  }
  return getUmbracoMediaUrl(url)
}
